import { useEffect, useRef, useState } from 'react';
import { useApp } from '../context.js';

// Keeps the text locally and saves after you pause typing (600 ms) or leave the field, instead of on every keystroke.
export default function NotesField({ restaurant }) {
    const { updateNotes } = useApp();
    const [text, setText] = useState(restaurant.notes || '');
    const dirty = useRef(false);
    const timer = useRef(null);
    const latest = useRef(text);
    latest.current = text;

    // Take remote changes when we are not mid-edit
    useEffect(() => {
        if (!dirty.current) setText(restaurant.notes || '');
    }, [restaurant.notes]);

    const flush = () => {
        clearTimeout(timer.current);
        if (!dirty.current) return;
        dirty.current = false;
        if (latest.current !== (restaurant.notes || '')) updateNotes(restaurant.id, latest.current);
    };

    // Save on unmount (card collapsed while typing)
    useEffect(() => () => flush(), []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="pt-3 border-t border-gray-100">
            <label htmlFor={`notes-${restaurant.id}`} className="block text-sm font-bold text-gray-700 mb-2">📝 General Notes:</label>
            <textarea
                id={`notes-${restaurant.id}`}
                value={text}
                onChange={(e) => {
                    setText(e.target.value);
                    dirty.current = true;
                    clearTimeout(timer.current);
                    timer.current = setTimeout(flush, 600);
                }}
                onBlur={flush}
                placeholder="Add general notes... (e.g., 'Great happy hour 4-6pm')"
                className="w-full px-3 py-2 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-base resize-none"
                rows="2"
            />
        </div>
    );
}
